import { cx } from "@jugl-web/utils";
import React, { FC } from "react";
import { CONTAINER_PADDING } from "../../consts";

interface BackdropContainerProps {
  alignment: "left" | "right";
  isBackdropVisible: boolean;
  className?: string;
  children: React.ReactNode;
}

export const BackdropContainer: FC<BackdropContainerProps> = ({
  alignment,
  isBackdropVisible,
  className,
  children,
}) => {
  const isRight = alignment === "right";

  return (
    <div
      className={cx(
        "animate-fade-in relative flex h-full max-h-[800px] min-h-[500px] w-[506px] shrink-0 flex-col items-center gap-4",
        isRight ? "rounded-br-2xl" : "rounded-bl-2xl",
        className
      )}
      style={{
        paddingLeft: CONTAINER_PADDING,
        paddingRight: CONTAINER_PADDING,
        paddingBottom: isBackdropVisible ? CONTAINER_PADDING : undefined,
        background: isBackdropVisible
          ? "linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #F2F2F2 100%)"
          : undefined,
      }}
    >
      {/* Gradient fading border overlay (mask trick) */}
      {isBackdropVisible && (
        <div
          aria-hidden="true"
          className={cx(
            "pointer-events-none absolute inset-0",
            isRight ? "rounded-br-2xl" : "rounded-bl-2xl"
          )}
          style={{
            border: "2px solid transparent",
            background: isRight
              ? "linear-gradient(to bottom right, transparent 50%, #E0E1E3 100%) border-box"
              : "linear-gradient(to bottom left, transparent 50%, #E0E1E3 100%) border-box",
            WebkitMask:
              "linear-gradient(white, white) padding-box, linear-gradient(white, white)",
            WebkitMaskComposite: "destination-out",
            maskComposite: "exclude",
          }}
        />
      )}
      {children}
    </div>
  );
};
